<template>
    <div>
        <div v-if="measurementsExist">
            <div >

              <b-alert v-if="isSessionComplete == false" show variant="warning">Session Recording is in-progress. Analysis report may not be available, measurement data tables are available.</b-alert>

              <b-card no-body class="overflow-hidden m-2" style="max-width: 500px;" >
                    <b-row no-gutters>
                        <b-col md="4" class="text-center" align-v="center">
                            <font-awesome-icon icon="file-pdf" class="m-2 mt-4 fa-4x" />
                        </b-col>
                        <b-col md="8">
                            <b-card-body title="PDF Report">
                                <b-card-text>
                                    <span>Print-ready report for the athlete.</span><br>
                                    <span>Report is customized based on protocol.</span>
                                </b-card-text>
                                <b-button variant="primary" v-on:click.stop="onDownloadReport()"><font-awesome-icon icon="file-download" /> Download</b-button>
                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>



              <b-card no-body class="overflow-hidden m-2" style="max-width: 500px;">
                    <b-row no-gutters>
                        <b-col md="4" class="text-center" align-v="center">
                            <font-awesome-icon icon="file-pdf" class="m-2 mt-4 fa-4x" />
                            <font-awesome-icon icon="table" class="m-2 mt-4 fa-4x" />
                        </b-col>
                        <b-col md="8">
                            <b-card-body title="Report and Data Tables">
                                <b-card-text>
                                    <span>Print-ready report for the athlete.</span><br>
                                    <span>Data tables for further analysis.</span>
                                </b-card-text>
                                <b-button variant="primary" v-on:click.stop="onDownloadReportAndDataTables()"><font-awesome-icon icon="file-download" /> Download</b-button>

                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>

                <b-card no-body class="overflow-hidden m-2" style="max-width: 500px;">
                    <b-row no-gutters>
                        <b-col md="4" class="text-center" align-v="center">
                            <font-awesome-icon icon="table" class="m-2 mt-4 fa-4x" />
                            <font-awesome-icon icon="table" class="m-2 mt-4 fa-3x" />
                        </b-col>
                        <b-col md="8">
                            <b-card-body title="Detailed Data Tables">
                                <b-card-text>
                                    <span>In depth data tables for data analysis.</span>
                                </b-card-text>
                                <b-button variant="primary" v-on:click.stop="onDownloadExtendedDataTables()"><font-awesome-icon icon="file-download" /> Download</b-button>

                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>

            </div>
        </div>
        <div v-else class="text-center">
            <h5>No Measurement data available</h5>
        </div>

        <MeasurementReportModal :includePDFReport="includePDFReport"
                                :includeDataTables="includeDataTables"
                                :includeExtendedDataTables="includeExtendedDataTables"/>

    </div>
</template>

<script>
    import MeasurementReportModal from './MeasurementReportModal'
    import { mapGetters } from 'vuex'

    export default {
        name: "SessionReportTab",
        components: {
            MeasurementReportModal
        },
        props: ['measurementData', 'measurementsExist'],
        data() {
            return {
                includePDFReport: false,
                includeDataTables: false,
                includeExtendedDataTables: false,
            }
        },
        computed: {
          ...mapGetters({
            session: 'session/current',
            sessionLoading: 'session/currentLoadingOrNull',
          }),

          isSessionComplete() {
            return !this.sessionLoading && this.session && this.session.isComplete;
          },

        },
        methods: {

            onDownloadReport() {
                this.includePDFReport = true;
                this.includeDataTables = false;
                this.includeExtendedDataTables = false;
                this.startDownload();
            },
            onDownloadReportAndDataTables() {
                this.includePDFReport = true;
                this.includeDataTables = true;
                this.includeExtendedDataTables = false;
                this.startDownload();
            },
            onDownloadExtendedDataTables() {
                this.includePDFReport = true;
                this.includeDataTables = true;
                this.includeExtendedDataTables = true;
                this.startDownload();
            },

          startDownload() {
            if(!this.session)
              return false;

            this.$bvModal.show('report-measurement-modal')
          }

        }
    }
</script>

<style scoped>

</style>